import React from 'react';
import Container from './components/Container'
import firebase from "firebase/app";
import {
  FirebaseDatabaseProvider,
  FirebaseDatabaseNode
} from "@react-firebase/database";
import { config } from "./config";

import "firebase/database";

import './App.scss';

const App: React.FunctionComponent = () => {
  return (
    <FirebaseDatabaseProvider 
      firebase={firebase}
      {...config}>
        <FirebaseDatabaseNode
              path="/"
            >
              {data => { 
                // console.log(data);
                return <Container data={data} />
              }}
            </FirebaseDatabaseNode>
      </FirebaseDatabaseProvider>
  );
}

export default App;
